import "../../../FhRadioInput.css";
import { computed, withDirectives, openBlock, createElementBlock, mergeProps, vShow } from "vue";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _sfc_main = /* @__PURE__ */ Object.assign({
  inheritAttrs: false
}, {
  __name: "FhRadioInput",
  props: {
    valid: {
      type: Boolean,
      required: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const computedClasses = computed(() => [
      "fh-radio",
      !props.valid && "fh-radio--invalid"
    ]);
    return (_ctx, _cache) => {
      return withDirectives((openBlock(), createElementBlock("input", mergeProps({
        class: computedClasses.value,
        type: "radio"
      }, _ctx.$attrs), null, 16)), [
        [vShow, !props.hidden]
      ]);
    };
  }
});
const FhRadioInput = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-00834b5d"]]);
export {
  FhRadioInput as default
};
//# sourceMappingURL=FhRadioInput.mjs.map
